// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Aufgabe, AufgabeDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateAufgabe(): (
  requestBody: AufgabeDaten
) => Promise<Aufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).aufgaben.createAufgabe({ requestBody }),
    [getAPI]
  );
}
